import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { config } from '../constants/config';
import { addVoiceSnippet } from './voiceSnippetSlice';
import { addTextSnippet } from './textSnippetSlice';
// Async thunk for uploading audio to S3
// let globalMediaRecorder = null;

// export const uploadAudioToS3 = createAsyncThunk(
//   'voiceSampleRec/uploadAudioToS3',
//   async ({ audioBlob, fileName, userId }) => {
//     const formData = new FormData();
//     formData.append('audio', audioBlob, fileName);
//     const response = await axios.post(`${config.UPLOAD_API_AUDIO_SNIPPET}/${userId}`, formData, {
//       headers: {
//         'Content-Type': 'multipart/form-data',
//       },
//     });
//     return response.data.fileUrl;
//   }
// );

// export const uploadTextSnippetToS3 = createAsyncThunk(
//   'voiceSampleRec/uploadTextSnippetToS3',
//   async ({ textSnippet, fileName, userId }) => {
//     const response = await axios.post(`${config.UPLOAD_API_TEXT_SNIPPET}/${userId}/${fileName}`, { textSnippet });
//     return response.data.fileUrl;
//   }
// );

// // ... other async thunks for uploadTextSnippetToS3, saveFileToNeo4j, etc.
// export const saveFileToNeo4j = createAsyncThunk(
//   'voiceSampleRec/saveFileToNeo4j',
//   async ({ userId, fileName, variation, s3Url, version, uuid }, { dispatch }) => {
//     // Dispatch the action to save the audio file details to Neo4j (or any other database)
//     dispatch(addVoiceSnippet({
//       userId,
//       fileName,
//       variation,
//       s3Url,
//       version,
//       uuid
//     }));
//   }
// );

// export const saveTextFileToNeo4j = createAsyncThunk(
//   'voiceSampleRec/saveTextFileToNeo4j',
//   async ({ userId, fileName, variation, s3TextUrl, version, uuid }, { dispatch }) => {
//     // Dispatch the action to save the text file details to Neo4j
//     dispatch(addTextSnippet({
//       userId,
//       fileName,
//       variation,
//       s3Url: s3TextUrl,
//       version,
//       uuid
//     }));
//   }
// );

// export const startRecordingAsync = () => async (dispatch, getState) => {
//   try {
//     const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
//     const recorder = new MediaRecorder(stream);

//     recorder.addEventListener('dataavailable', (event) => {
//       console.log('startRecordingAsync addEventListener', getState().user.voiceSampleRec)
//       const currentAudioChunks = getState().user.voiceSampleRec.audioChunks;
//       dispatch(setAudioChunks([...currentAudioChunks, event.data]));
//     });

//     recorder.start();
//     globalMediaRecorder = recorder;
//     dispatch(startRecording());
//   } catch (error) {
//     console.error('Error starting recording:', error);
//   }
// };

// export const stopRecordingAsync = () => (dispatch) => {
//   if (globalMediaRecorder) {
//     globalMediaRecorder.stop();
//     globalMediaRecorder = null;
//     dispatch(stopRecording());
//   }
// };

// export const saveRecordingAsync = (values) => async (dispatch, getState) => {
//   const { audioChunks, userId } = getState().user.voiceSampleRec; // Assuming userId is part of the slice state
//   dispatch(setSaveStatus('saving'));
//   let uuid = uuidv4();
//   const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });
//   const formattedFileName = `${values.fileName}.wav`;
//   const formattedTextFileName = `${values.fileName}.txt`;

//   try {
//     let s3Url = await dispatch(uploadAudioToS3({ audioBlob, fileName: formattedFileName, userId })).unwrap();
//     let s3TextUrl = await dispatch(uploadTextSnippetToS3({ textSnippet: "This should be the snippet text", fileName: formattedTextFileName, userId })).unwrap();

//     await dispatch(saveFileToNeo4j({ userId, fileName: formattedFileName, variation: values.variation, s3Url, version: 1, uuid })).unwrap();
//     await dispatch(saveTextFileToNeo4j({ userId, fileName: formattedTextFileName, variation: values.variation, s3TextUrl, version: 1, uuid })).unwrap();

//     dispatch(setSaveStatus('saved'));
//   } catch (error) {
//     // Handle errors
//     console.error('Error saving recording:', error);
//     dispatch(setSaveStatus('error'));
//   }
// };

const voiceSampleRecSlice = createSlice({
  name: 'voiceSampleRec',
  initialState: {
    // ... other initial state values
    audioChunks: [],
    saveStatus: 'idle',
    mediaRecorder: null,
    // Add other relevant state for the recording process
  },
  reducers: {
    startRecording: (state, action) => {
      // Handle start recording logic
      // You may need to move the logic for starting the MediaRecorder here
      state.saveStatus = 'recording';
    },
    stopRecording: (state, action) => {
      // Handle stop recording logic
      // You may need to move the logic for stopping the MediaRecorder here
      state.saveStatus = 'ready';
    },
    deleteRecording: (state, action) => {
      // Handle delete recording logic
      state.audioChunks = [];
      state.saveStatus = 'idle';
    },
    setAudioChunks: (state, action) => {
      // Handle setting audio chunks
      state.audioChunks = action.payload;
    },
    setSaveStatus: (state, action) => {
      state.saveStatus = action.payload;
    },
    // ... other synchronous reducers
  },
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(uploadAudioToS3.fulfilled, (state, action) => {
  //       // Handle successful audio upload
  //       // Update state based on the successful upload
  //     })
  //     .addCase(uploadAudioToS3.rejected, (state, action) => {
  //       // Handle failed audio upload
  //       // Update state based on the failed upload
  //     });
  //   // ... handle other async thunks
  // },
});

export const { startRecording, stopRecording, deleteRecording, setAudioChunks, setSaveStatus } = voiceSampleRecSlice.actions;

// Selectors
// ... export selectors related to the recording process
export const selectMediaRecorder = (state) => state.user.voiceSampleRec.mediaRecorder;
export const selectSaveStatus = (state) => state.user.voiceSampleRec.saveStatus;

export default voiceSampleRecSlice.reducer;
